import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { CookieBannerComponent } from './cookie-banner.component';
import { DigitizePlaceholderComponent } from './components/digitize/digitize-placeholder.component';
import { ModeSelectionComponent } from './components/mode-selection/mode-selection.component';
import { DossierListComponent } from './components/dossier-list/dossier-list.component';
import { DossierDetailComponent } from './components/dossier-detail/dossier-detail.component';
import { UploadDocumentsComponent } from './components/upload-documents/upload-documents.component';
import { ExtractionReviewComponent } from './components/extraction-review/extraction-review.component';
import { ExtractionSummaryComponent } from './components/extraction-summary/extraction-summary.component';
import { DossierVerificationComponent } from './components/dossier-verification/dossier-verification.component';
import { ModelTierSliderComponent } from './components/model-tier-slider/model-tier-slider.component';
import { AgentChatComponent } from './components/agent-chat/agent-chat.component';
import { SignatureBadgeComponent } from './components/signature-badge/signature-badge.component';
import { SignaturePanelComponent } from './components/signature-panel/signature-panel.component';
import { LocalDateTimePipe, LocalNumberPipe } from './pipes/local-format.pipes';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const routes: Routes = [
  { path: '', component: ModeSelectionComponent },
  { path: 'digitize', component: DigitizePlaceholderComponent },
  { path: 'dossiers', component: DossierListComponent },
  { path: 'dossiers/:id', component: DossierDetailComponent },
  { path: 'dossiers/:id/uploads/:uid/review', component: UploadDocumentsComponent },
  { path: 'dossiers/:id/uploads/:uid/extraction-review', component: ExtractionSummaryComponent },
  { path: 'dossiers/:id/uploads/:uid/documents/:did/extract', component: ExtractionReviewComponent },
  { path: 'dossiers/:id/verification', component: DossierVerificationComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  declarations: [
    AppComponent,
    CookieBannerComponent,
    DigitizePlaceholderComponent,
    ModeSelectionComponent,
    DossierListComponent,
    DossierDetailComponent,
    UploadDocumentsComponent,
    ExtractionReviewComponent,
    ExtractionSummaryComponent,
    DossierVerificationComponent,
    ModelTierSliderComponent,
    AgentChatComponent,
    SignatureBadgeComponent,
    SignaturePanelComponent,
    LocalDateTimePipe,
    LocalNumberPipe,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(routes),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
